import React from 'react';
import ReactDOM from 'react-dom/client';
// Add this line to ensure Tailwind's necessary boilerplate is included in the build
import './index.css'; 
import App from './App'; // Import your main component

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);